import * as Yup from "yup";


// Constants
export const INITIAL_VALUES_1 = {
    dispatch_temperature: '',
    dispatch_time: "",
};
export const INITIAL_VALUES_2 = {
    "receipt_date": "",
    "patient_details_verified": false,
    "leakage_observed": false,
    "broken_seal": false,
    "broken_transport_box_comment":"",
    "broken_seal_comment":"",
    "leakage_observed_comment":"",
    "broken_transport_box": false,
    "receipt_time": "",
    "quantity_received": "",
    "receipt_temperature": "",
    "temperature_excursion_comment": "",
    "excursion_time": "",
    "excursion_temp": "",
    "excursion_duration": "",
}

export const STEP_SLUGS = {
    QUALITY_CONTROL: "qc-testing",
    PRODUCT_SHIPPED: "product-shipped",
    INFUSION: "infusion",
    PRODUCT_RECEIVED: "product-received"
};

export const STATUS_COMPLETED = 2;
export const STATUS_IN_PROGRESS = 1;
export const STATUS_SUBMITED = 4
export const STATUS_PENDING = 0

export const validationSchemaOutbondPart1 = Yup.object().shape({
    dispatch_temperature: Yup.number()
        .nullable()
        .typeError("Temperature at dispatch must be a number")
        .required("Temperature at dispatch is required")
        .max(100, "Temperature at dispatch cannot be more than 100")
        .test(
            "max-2-decimals",
            "Temperature at dispatch can have at most 2 decimal places",
            (value) =>
                value == null ||
                /^-?\d+(\.\d{1,2})?$/.test(value.toString()) // allow optional minus
        ),



    dispatch_time: Yup.string().required("Time of dispatch is required"),
});
export const validationSchemaOutbondPart2 = Yup.object().shape({
    receipt_date: Yup.string().required("Time of receipt is required").nullable(),

    patient_details_verified: Yup.boolean().required("Patient details verified is required").nullable(),


    quantity_received: Yup.number()
        .nullable()
        .required("Quantity received is required"),

    leakage_observed: Yup.boolean().required("Leakage check is required").nullable(),
 leakage_observed_comment: Yup.string()
  .nullable()
  .when("leakage_observed", {
    is: (val) => val === true,   // boolean comparison
    then: (schema) =>
      schema
        .nullable()
        .required("Leakage check's comment is required"),
    otherwise: (schema) =>
      schema.nullable().notRequired(),
  }),
     broken_seal: Yup.boolean()
  .nullable()
  .required("Broken seal check is required"),
 broken_seal_comment: Yup.string()
  .nullable()
  .when("broken_seal", {
    is: (val) => val === true,   // boolean comparison
    then: (schema) =>
      schema
        .nullable()
        .required("Broken seal check's comment is required"),
    otherwise: (schema) =>
      schema.nullable().notRequired(),
  }),
     broken_transport_box: Yup.boolean()
  .nullable()
  .required("Broken transport box damaged check is required"),
 broken_transport_box_comment: Yup.string()
  .nullable()
  .when("broken_transport_box", {
    is: (val) => val === true,   // boolean comparison
    then: (schema) =>
      schema
        .nullable()
        .required("Broken transport box damaged's comment is required"),
    otherwise: (schema) =>
      schema.nullable().notRequired(),
  }),
    temperature_excursion: Yup.boolean()
    .nullable()
    .required("Temperature excursion is required"),

   receipt_temperature: Yup.number()
  .nullable()
  .when("temperature_excursion", {
    is: (val) =>  val === "true" || val === true,  // boolean comparison
    then: (schema) =>
      schema
        .nullable()
        .typeError("Excursion temperature at dispatch must be a number")
        .required("Excursion temperature at dispatch is required")
        .max(100, "Excursion temperature at dispatch cannot be more than 100")
        .test(
            "max-2-decimals",
            "Excursion temperature at dispatch can have at most 2 decimal places",
            (value) =>
                value == null ||
                /^-?\d+(\.\d{1,2})?$/.test(value.toString()) // allow optional minus
        ),
    otherwise: (schema) =>
      schema.nullable().notRequired(),
  }),
     receipt_time: Yup.string()
  .nullable()
  .when("temperature_excursion", {
    is: (val) =>  val === "true" || val === true,  // boolean comparison
    then: (schema) =>
      schema
        .nullable()
        .required("Excursion time check is required"),
    otherwise: (schema) =>
      schema.nullable().notRequired(),
  }),
   temperature_excursion_comment: Yup.string()
  .nullable()
  .when("temperature_excursion", {
    is: (val) =>  val === "true" || val === true,  // boolean comparison
    then: (schema) =>
      schema
        .nullable()
        .required("Excursion duration's comment is required"),
    otherwise: (schema) =>
      schema.nullable().notRequired(),
  }),
      excursion_duration: Yup.string()
  .nullable()
  .when("temperature_excursion", {
    is: (val) => val === "true" || val === true,
    then: (schema) =>
      schema
        .nullable()
        .required("Excursion duration is required")
        .matches(
          /^(?:[01]\d|2[0-3])[:-][0-5]\d$/,
          "Excursion duration must be in HH:MM or HH-MM format (e.g., 22:33)"
        ),
    otherwise: (schema) =>
      schema.nullable().notRequired(),
  })
});